// extracted by mini-css-extract-plugin
export default {"successLog":"Pedidos_successLog__X9JIU","errorLog":"Pedidos_errorLog__3fnXj","swal-popup":"Pedidos_swal-popup__-Hh4V"};